import { createAsyncThunk } from '@reduxjs/toolkit';
import { createMaskedValue } from '@/libs/helpers/utils';
import { TIME_MASK } from '@/libs/constants';
import { validateFlightTime } from '@/libs/validation/validateFlightTime';
import { validateFlightDeparture } from '@/libs/validation/validateFlightDeparture';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const setFlightTimeFrom = createAsyncThunk('flights/setFlightTimeFrom', async ({ _uuid, value }, thunkApi) => {
    const maskedValue = createMaskedValue(value, TIME_MASK);
    const state = thunkApi.getState();
    const flight = state.flights.flights.find((f) => f._uuid === _uuid);
    const { error: timeError } = validateFlightTime(maskedValue);
    const { error: departureError } = validateFlightDeparture({
        dateFrom: flight?.dateFrom || '',
        timeFrom: maskedValue,
    });
    const error = timeError || departureError;
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.timeFrom,
        value: maskedValue,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.timeFrom,
        error,
    }));
    if (!error) {
        if (flight) {
            const { error: timeToError } = validateFlightTime(flight.timeTo, {
                dateFrom: flight.dateFrom,
                dateTo: flight.dateTo,
                timeFrom: maskedValue,
            });
            thunkApi.dispatch(flightsActions._setFlightFieldError({
                _uuid,
                field: FlightField.timeTo,
                error: timeToError,
            }));
        }
    }
});
export const setFlightTimeTo = createAsyncThunk('flights/setFlightTimeTo', async ({ _uuid, value }, thunkApi) => {
    const maskedValue = createMaskedValue(value, TIME_MASK);
    const state = thunkApi.getState();
    const flight = state.flights.flights.find((f) => f._uuid === _uuid);
    const { error } = validateFlightTime(maskedValue, {
        dateFrom: flight?.dateFrom || '',
        dateTo: flight?.dateTo || '',
        timeFrom: flight?.timeFrom || '',
    });
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.timeTo,
        value: maskedValue,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.timeTo,
        error,
    }));
});
